import { render, staticRenderFns } from "./StandardKey.vue?vue&type=template&id=681c47a0&"
import script from "./StandardKey.vue?vue&type=script&lang=js&"
export * from "./StandardKey.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports